// frontend/src/pages/org/org-plans-page.tsx
// Read DESIGN.md before modifying this file.
import { useParams } from 'react-router';
import { PlansSection } from '@/components/billing/plans-section';
import { OrgUsageBanner } from '@/components/org-usage-banner';
import { RoleGate } from '@/components/auth/role-gate';
import { MemberBillingPlaceholder } from '@/components/auth/member-billing-placeholder';
import { PageContainer } from '@/components/page-container';
import { useSidebarOrgUsageQuery } from '@/components/billing/queries';
import { isValidPublicId } from '@/lib/public-id';

/**
 * Plans page (spec 2026-06-18 split): capacity & spend — tier selection, the
 * Custom and SaaS Mode cards, org-pooled usage, overflow, and top-up. Org-admin
 * only; non-admins get the admin-required placeholder (the nav item is hidden
 * for them in OrgSidebar).
 */
export function OrgPlansPage() {
  const { orgId } = useParams<{ orgId: string }>();
  const validOrgId = orgId && isValidPublicId(orgId, 'org') ? orgId : null;
  const usageQuery = useSidebarOrgUsageQuery(validOrgId);
  const usage = usageQuery.isError ? null : usageQuery.data;

  return (
    <PageContainer variant="fill" className="gap-4">
      <h1 className="text-xl font-semibold">Plans</h1>
      {/* No Upgrade CTA — the tier cards below are the upgrade action. Self-gates <75%. */}
      {validOrgId && usage && (
        <OrgUsageBanner
          orgId={validOrgId}
          percentage={usage.percentage}
          showCta={false}
          unitLabel={usage.usageUnit === 'actions' ? 'actions' : 'messages'}
          channelsPaused={usage.channelsPaused}
          reserveBalance={usage.reserveBalance}
        />
      )}
      <RoleGate role="admin" fallback={<MemberBillingPlaceholder />}>
        <PlansSection />
      </RoleGate>
    </PageContainer>
  );
}
